import { languages } from "../constants/languages";

export const GET_CHECKOUT_AUTH_URL_ENDPOINT =
  "https://us-central1-tournamentsoftware-a1b3d.cloudfunctions.net/checkout_getCheckoutAuthUrl";

// Collects the tournament dates and requests a checkout auth URL from the
// new platform. Returns the URL, or null when it could not be fetched.
export const getUpgradeCheckoutURL = async (
  tournamentId,
  tournament,
  product = "worldclass" // worldclass, legendary, community, professional
) => {
  try {
    const token = await window.firebase.auth().currentUser?.getIdToken();

    // Get days inside tournament collection
    const daysDoc = await window.firebase
      .firestore()
      .collection("tournaments")
      .doc(tournamentId)
      .collection("days")
      .get();

    const days = [
      tournament.date,
      ...daysDoc.docs.map((doc) => doc.data().date),
    ].sort((a, b) => a - b);
    const firstDay = days[0];
    const lastDay = days[days.length - 1];

    const isEsport = tournament.online === true;
    const redirectURL = "/legacy/checkout"

    const response = await fetch(
      GET_CHECKOUT_AUTH_URL_ENDPOINT,
      {
        method: "POST",
        body: JSON.stringify({
          data: {
            locale: languages.getLanguage(),
            product: isEsport ? "esports" : product,
            firebase_tid: tournamentId,
            tdate_start: firstDay,
            tdate_end: lastDay,
            redirect_url: redirectURL,
          },
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const json = await response.json();
    const url = json.result?.url || null;

    if (!url) {
      throw new Error(`No checkout auth URL returned from the server. ${JSON.stringify(json)}`);
    }
    
    return url;
  } catch (error) {
    console.error("Error fetching checkout auth URL or tournament days:", error);
    if (window.firebase && window.firebase.analytics) {
      window.firebase
        .analytics()
        .logEvent("checkout_url_fetch_failed", {
          product: tournament?.online === true ? "esports" : product,
          tournament_id: tournamentId,
          error_code: error?.code || "unknown_error",
          error_message: (error?.message || "unknown_error").slice(0, 200),
        });
    }
    return null;
  }
};
